// find the correct subitem based on the subroute
export const getAppRouteData = (app = {}, subRoute = '') => {
  if (!app.menu_items?.subitems) return undefined;
  
  // Try exact match first
  let match = app.menu_items.subitems.find((item) => item.route === subRoute);
  
  // If no exact match and app name is in the route, try matching the last segment
  if (!match && subRoute) {
    const appName = app.app_code_name;
    match = app.menu_items.subitems.find((item) => item.route === `/${appName}/${subRoute}`);
  }
  
  return match;
};

/**
 * Localized title for the menu subitem behind an app route.
 *
 * Subitems carry their translations in `item_name`, a locale map. The v2 menu endpoint
 * additionally synthesizes an already-localized `key`, but v3's menu_items extension ships
 * only `item_name` — so resolve that first and keep `key` for the v2 shape (SUPPORT-13211).
 * Returns undefined when there is nothing to show, so callers keep their own fallback.
 */
export const getAppRouteTitle = (app, subroute = '', locale = 'en') => {
  const subrouteItem = getAppRouteData(app, subroute);
  if (!subrouteItem) return undefined;

  const itemName = subrouteItem.item_name;
  return itemName?.[locale] || itemName?.en || subrouteItem.key || undefined;
};

export const getAppPermissions = (app, subroute = '') => {
  // find the correct subitem based on the subroute
  const subrouteItem = getAppRouteData(app, subroute);
  return subrouteItem?.permissions;
};

export const isImpersonationBlocked = (app, subroute = '') => {
  // find the correct subitem based on the subroute
  const subrouteItem = getAppRouteData(app, subroute);
  return Boolean(subrouteItem?.block_impersonation);
};
